import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";

export const accountIdPrefix = "acc_";
export type AccountId = ID<typeof accountIdPrefix>;
export const generateAccountId = makeIdGenerator(accountIdPrefix);
export const accountIdSchema = getIdSchema(accountIdPrefix, "AccountId");

export const accountSchema = z
  .object({
    id: accountIdSchema,
  })
  .meta({ id: "Account" });

export type Account = z.infer<typeof accountSchema>;
